module.exports = __webpack_public_path__ + "img/attach-muted.f55c0007.svg";